import React, { useEffect, useState } from "react";
import styles from "./VideoBlock.module.css";
import DeleteButton from "../../../reusable/Button/DeleteButton";
import { getVimeoLink, getYoutubeLink } from "../../../../helpers/getVideoLink";
import VideoPoster from "../../../../assets/videoPoster.jpg";

export default function VideoBlock({ src, onDelete }) {
	const [state, setState] = useState({
		iframe: false,
		src: "",
	});

	useEffect(() => {
		validateUrl(src);
		(() => {
			let div = document.getElementById("video");
			div.style.backgroundImage = `url(${VideoPoster})`;
		})();
	}, [src]);

	const validateUrl = async (url) => {
		if (url !== undefined || url !== "") {
			let link = await getYoutubeLink(url);
			if (link) {
				setState({
					...state,
					iframe: true,
					src: link,
				});
			} else {
				link = await getVimeoLink(url);
				if (link)
					setState({
						...state,
						iframe: true,
						src: link,
					});
				else {
					setState({
						...state,
						iframe: false,
						src: url,
					});
				}
			}
		}
	};

	return (
		<div className={styles.videoBlock}>
			{onDelete ? (
				<div className={styles.deleteBtn}>
					<DeleteButton action={() => onDelete()} />
				</div>
			) : null}
			{state.iframe ? (
				<iframe
					id="video"
					title="Video"
					type="text/html"
					className={styles.video}
					src={state.src}
					frameBorder="0"
					allowFullScreen
				></iframe>
			) : (
				<video
					id="video"
					className={styles.video}
					controls="controls"
					src={state.src}
				></video>
			)}
		</div>
	);
}
